import React, { useEffect, useState } from "react";
import { FormattedMessage } from 'react-intl';
// Helpers, Utils etc.
import countryCodes from "../../helpers/countryCodes";

interface ITosGeneralProps {
  company: any;
  paymentTypes: any;
}

function TosGeneral({ company, paymentTypes }: ITosGeneralProps) {
  const [countryName, setCountryName] = useState("");
  const [omisePayment, setOmisePayment] = useState(null);
  let sectionNumber = 1;

  useEffect(() => {
    if (company.country_code) {
      let country = countryCodes.find((countryObj: any) => {
        return countryObj.code == company.country_code;
      });
      if (country && country.name) {
        setCountryName(country.name);
      }
    }
  }, [company.country_code]);

  useEffect(() => {
    const omisePType = paymentTypes.find((pType: any) => {
      return pType.payment_type == 'omise';
    });
    setOmisePayment(omisePType);
  }, [paymentTypes]);

  return (
    <div className="tos-page">
      <div className="container">
        <h1 className="text-center">
          <FormattedMessage id="terms_of_service.header" values={{ companyName: company.name }} />
        </h1>

        <h5>
          <FormattedMessage id="terms_of_service.disclaimer.header" />
        </h5>
        <p>
          <FormattedMessage id="terms_of_service.disclaimer.line_1" />
        </p>
        <p>
          <FormattedMessage id="terms_of_service.disclaimer.line_2" />
        </p>
        <p>
          <FormattedMessage id="terms_of_service.disclaimer.line_3" values={{ companyName: company.name, websiteURL: company.website_url, aTag: (text) => <a href={company.website_url}>{text}</a> }} />
        </p>

        <h5>
          <FormattedMessage id="terms_of_service.terms_of_use.header" />
        </h5>
        <p>
          <FormattedMessage id="terms_of_service.terms_of_use.line_1" values={{ companyName: company.name }} />
        </p>
        <p>
          <FormattedMessage id="terms_of_service.terms_of_use.line_2" values={{ companyName: company.name }} />
        </p>
        <p>
          <FormattedMessage id="terms_of_service.terms_of_use.line_3" values={{ companyName: company.name }} />
        </p>

        <h5>
          <FormattedMessage id="terms_of_service.intended_audience_and_use.header" values={{ sectionNumber: sectionNumber }} />
        </h5>
        <p>
          <FormattedMessage id="terms_of_service.intended_audience_and_use.line_1" values={{ companyName: company.name, countryName: countryName }} />
        </p>
        <p>
          <FormattedMessage id="terms_of_service.intended_audience_and_use.line_2" values={{ companyName: company.name }} />
        </p>
        <p>
          <FormattedMessage id="terms_of_service.intended_audience_and_use.line_3" />
        </p>
        <ol type="a">
          <li>
            <FormattedMessage id="terms_of_service.intended_audience_and_use.line_3.point_1" values={{ companyName: company.name }} />
          </li>
          <li>
            <FormattedMessage id="terms_of_service.intended_audience_and_use.line_3.point_2" values={{ companyName: company.name }} />
          </li>
        </ol>
        <p>
          <FormattedMessage id="terms_of_service.intended_audience_and_use.line_4" />
        </p>

        <h5>
          <FormattedMessage id="terms_of_service.user_conduct_and_rules.header" values={{ sectionNumber: sectionNumber += 1 }} />
        </h5>
        <p>
          <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1" />
        </p>
        <ol>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_1" values={{ companyName: company.name }} />
          </p>
          <ol type='i'>
            <li>
              <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_1.sub_point_1" />
            </li>
            <li>
              <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_1.sub_point_2" />
            </li>
            <li>
              <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_1.sub_point_3" />
            </li>
            <li>
              <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_1.sub_point_4" values={{ companyName: company.name }} />
            </li>
            <li>
              <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_1.sub_point_5" />
            </li>
          </ol>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_2" values={{ companyName: company.name }} />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_3" values={{ companyName: company.name }} />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_4" values={{ countryName: countryName }} />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_5" values={{ companyName: company.name }} />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_6" values={{ companyName: company.name }} />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_7" values={{ companyName: company.name }} />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_8" values={{ companyName: company.name }} />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_9" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_10" values={{ companyName: company.name }} />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.user_conduct_and_rules.line_1.point_11" values={{ companyName: company.name }} />
          </p>
        </ol>

        <h5>
          <FormattedMessage
            id="terms_of_service.responsibility_of_contributors.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>

        <p>
          <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1" />
        </p>
        <ol>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_1" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_2" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_3" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_4" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_5" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_6" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_7" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_8" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.responsibility_of_contributors.line_1.point_9" />
          </p>
        </ol>

        <h5>
          <FormattedMessage
            id="terms_of_service.general_terms.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>
        <ol>
          <p>
            <strong>
              <FormattedMessage id="terms_of_service.general_terms.line_1" />
            </strong>
          </p>
          <p>
            <FormattedMessage id="terms_of_service.general_terms.line_1.point_1" />
          </p>
          <p>
            <FormattedMessage
              id="terms_of_service.general_terms.line_1.point_2"
              values={{
                countryName: countryName
              }}
            />
          </p>
          <p>
            <strong>
              <FormattedMessage id="terms_of_service.general_terms.line_2" />
            </strong>
          </p>
          <p>
            <FormattedMessage id="terms_of_service.general_terms.line_2.point_1" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="terms_of_service.general_terms.line_3" />
            </strong>
          </p>
          <p>
            <FormattedMessage id="terms_of_service.general_terms.line_3.point_1" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="terms_of_service.general_terms.line_4" />
            </strong>
          </p>
          <p>
            <FormattedMessage
              id="terms_of_service.general_terms.line_4.point_1"
              values={{
                companyName: company.name,
                currency: company.currency,
              }}
            />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.general_terms.line_4.point_2" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.general_terms.line_4.point_3" />
          </p>
          <p>
            <FormattedMessage
              id="terms_of_service.general_terms.line_4.point_4"
              values={{ company_name: company.name }}
            />
          </p>
        </ol>

        <h5>
          <FormattedMessage
            id="terms_of_service.links_to_third_party_website.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>
        <p>
          <FormattedMessage
            id="terms_of_service.links_to_third_party_website.line_1"
            values={{
              companyName: company.name
            }}
          />
        </p>

        {omisePayment ? (
          <React.Fragment>
            <h5>
              <FormattedMessage
                id="terms_of_service.data_collection_and_privacy.header"
                values={{
                  sectionNumber: sectionNumber += 1
                }}
              />
            </h5>
            <p>
              <FormattedMessage
                id="terms_of_service.data_collection_and_privacy.line_1"
                values={{
                  companyName: company.name,
                }}
              />
            </p>
            <p>
              <FormattedMessage
                id="terms_of_service.data_collection_and_privacy.line_2"
                values={{
                  companyName: company.name,
                }}
              />
            </p>
            <p>
              <FormattedMessage id="terms_of_service.data_collection_and_privacy.line_3" />
            </p>
            <ol>
              <p>
                <strong>
                  <FormattedMessage id="terms_of_service.data_collection_and_privacy.information_collected.header" />
                </strong>
              </p>
              <p>
                <FormattedMessage
                  id="terms_of_service.data_collection_and_privacy.information_collected.line_1"
                  values={{
                    companyName: company.name,
                  }}
                />
              </p>
            </ol>
            <ol>
              <p>
                <strong>
                  <FormattedMessage id="terms_of_service.data_collection_and_privacy.use_and_care.header" />
                </strong>
              </p>
              <p>
                <FormattedMessage
                  id="terms_of_service.data_collection_and_privacy.use_and_care.line_1"
                  values={{
                    companyName: company.name,
                  }}
                />
              </p>
              <p>
                <FormattedMessage id="terms_of_service.data_collection_and_privacy.use_and_care.line_2" />
              </p>
              <p>
                <FormattedMessage
                  id="terms_of_service.data_collection_and_privacy.use_and_care.line_3"
                  values={{
                    companyName: company.name,
                  }}
                />
              </p>
              <p>
                <FormattedMessage
                  id="terms_of_service.data_collection_and_privacy.use_and_care.line_4"
                  values={{
                    companyName: company.name,
                  }}
                />
              </p>
            </ol>
            <ol>
              <p>
                <strong>
                  <FormattedMessage id="terms_of_service.data_collection_and_privacy.data_security.header" />
                </strong>
              </p>
              <p>
                <FormattedMessage
                  id="terms_of_service.data_collection_and_privacy.data_security.line_1"
                  values={{
                    companyName: company.name,
                  }}
                />
              </p>
              <p>
                <FormattedMessage
                  id="terms_of_service.data_collection_and_privacy.data_security.line_2"
                  values={{
                    companyName: company.name,
                  }}
                />
              </p>
              <p>
                <FormattedMessage
                  id="terms_of_service.data_collection_and_privacy.data_security.line_3"
                  values={{
                    companyName: company.name,
                  }}
                />
              </p>
            </ol>
            <ol>
              <p>
                <strong>
                  <FormattedMessage id="terms_of_service.data_collection_and_privacy.cookies_collection.header" />
                </strong>
              </p>
              <p>
                <FormattedMessage id="terms_of_service.data_collection_and_privacy.cookies_collection.line_1" />
              </p>
              <p>
                <FormattedMessage id="terms_of_service.data_collection_and_privacy.cookies_collection.line_2" />
              </p>
              <p>
                <FormattedMessage id="terms_of_service.data_collection_and_privacy.cookies_collection.line_3" />
              </p>
            </ol>
            <ol>
              <p>
                <strong>
                  <FormattedMessage id="terms_of_service.data_collection_and_privacy.dispute.header" />
                </strong>
              </p>
              <p>
                <FormattedMessage
                  id="terms_of_service.data_collection_and_privacy.dispute.line_1"
                  values={{
                    contactName: omisePayment['contact_name'],
                    contactEmail: omisePayment['contact_email'],
                  }}
                />
              </p>
            </ol>
          </React.Fragment>
        ) : null}

        <h5>
          <FormattedMessage
            id="terms_of_service.privacy_policy.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>
        <p>
          <FormattedMessage
            id="terms_of_service.privacy_policy.line_1"
            values={{
              companyName: company.name,
              websiteURL: company.website_url,
            }}
          />
        </p>

        <h5>
          <FormattedMessage
            id="terms_of_service.intellectual_property_rights.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>
        <ol>
          <p>
            <strong>
              <FormattedMessage id="terms_of_service.intellectual_property_rights.line_1" />
            </strong>
          </p>
          <p>
            <FormattedMessage
              id="terms_of_service.intellectual_property_rights.line_1.point_1"
              values={{
                companyName: company.name,
                websiteURL: company.website_url,
              }}
            />
          </p>
          <p>
            <strong>
              <FormattedMessage id="terms_of_service.intellectual_property_rights.line_2" />
            </strong>
          </p>
          <p>
            <FormattedMessage
              id="terms_of_service.intellectual_property_rights.line_2.point_1"
              values={{
                companyName: company.name
              }}
            />
          </p>
        </ol>

        <h5>
          <FormattedMessage
            id="terms_of_service.warranties_and_liability.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>
        <ol>
          <p>
            <FormattedMessage id="terms_of_service.warranties_and_liability.line_1" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.warranties_and_liability.line_2" />
          </p>
          <p>
            <FormattedMessage id="terms_of_service.warranties_and_liability.line_3" />
          </p>
        </ol>

        <h5>
          <FormattedMessage
            id="terms_of_service.govering_law.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>

        <p>
          <FormattedMessage
            id="terms_of_service.govering_law.line_1"
            values={{
              countryName: countryName
            }}
          />
        </p>

        <h5>
          <FormattedMessage
            id="terms_of_service.effectiveness.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>
        <p>
          <FormattedMessage id="terms_of_service.effectiveness.line_1" />
        </p>

        <h5>
          <FormattedMessage
            id="terms_of_service.prevailing_language.header"
            values={{
              sectionNumber: sectionNumber += 1
            }}
          />
        </h5>
        <p>
          <FormattedMessage id="terms_of_service.prevailing_language.line_1" />
        </p>
      </div>
    </div>
  );
}

export default TosGeneral; 